"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COPYWRITER_ROLES = exports.SUBMISSION_ROLES = exports.ADMIN_ROLES = exports.ROLE_PERMISSION_MAP = exports.AVAILABLE_ROLES_V2 = exports.PERMISSIONS = void 0;
exports.PERMISSIONS = [
    'REVENUE_R',
    'REVENUE_RW',
    'ADS_R',
    'ADS_RW',
    'PUBLISHING_APPADS_RW',
    'MAIN_APPADS_RW',
    'PUA_RW',
    'BUSINESS_R',
    'BUSINESS_RW',
    'HOMEPAGE_TEXT_RW',
    'NOTICE_RW',
    'BLOG_RW',
    'DEV_MANAGE_R',
    'DEV_MANAGE_RW',
    'GAM_RW',
    'TAG_R',
    'TAG_MINIMAL_R',
    'TAG_RW',
    'GAME_R',
    'GAME_MINIMAL_R',
    'GAME_RW',
    'GAME_UPLOAD_RW',
    'GAME_BUSINESS_REVIEW_RW',
    'COPYWRITER_RW',
    'ADMIN',
    // A separate permission to allow certain actions to both business and game admins
    'GAME_BUSINESS_COMMON_RW',
    // An additional permission to allow both business and game admins to add/update the Xsolla info and credentials
    'GAME_XSOLLA_RW',
    // Additional dev permission to allow both business and dev admins to change developer source
    'DEV_BUSINESS_RW',
];
exports.AVAILABLE_ROLES_V2 = [
    'SUPER_ADMIN',
    'COPYWRITER',
    'ADS_ADMIN',
    'PUBLISHING_APPADS_ADMIN',
    'MAIN_APPADS_ADMIN',
    'PUA_ADMIN',
    'FINANCE_ADMIN',
    'BUSINESS_ADMIN',
    'BUSINESS_READER',
    'BLOG_ADMIN',
    'DEV_MANAGER_ADMIN',
    'DP_ADMIN',
    'GAME_ADMIN',
    'GAME_READER',
    'GAME_BUSINESS_ADMIN',
    'GAME_SEO_ADMIN',
    'PORTAL_COPYWRITER',
    'ENGINEER',
    'ADMIN',
];
exports.ROLE_PERMISSION_MAP = {
    SUPER_ADMIN: [
    // can do everything
    ],
    ADMIN: [
        // general role for all internal members
        'ADMIN',
    ],
    COPYWRITER: ['GAME_MINIMAL_R', 'TAG_MINIMAL_R', 'COPYWRITER_RW', 'HOMEPAGE_TEXT_RW'],
    // mostly used for managing ads.txt and ads config, also for retrieving game revenue share per game unit
    ADS_ADMIN: ['ADS_RW', 'ADS_R'],
    // used by the publishing team for managing app-ads.txt, which is used in mobile games
    PUBLISHING_APPADS_ADMIN: ['PUBLISHING_APPADS_RW'],
    // used to update the app-ads.txt file for the main CrazyGames app
    MAIN_APPADS_ADMIN: ['MAIN_APPADS_RW'],
    // used for managing Paid User Acquisition (f.e. ad groups used in PUA campaigns)
    PUA_ADMIN: ['PUA_RW'],
    FINANCE_ADMIN: ['REVENUE_R', 'REVENUE_RW', 'GAME_R', 'GAME_MINIMAL_R', 'TAG_R', 'TAG_MINIMAL_R', 'DEV_MANAGE_R'],
    BUSINESS_ADMIN: [
        'REVENUE_R',
        'REVENUE_RW',
        'BUSINESS_R',
        'BUSINESS_RW',
        'GAME_BUSINESS_COMMON_RW',
        'GAME_XSOLLA_RW',
        'DEV_BUSINESS_RW',
        'DEV_MANAGE_R',
        'ADS_R',
    ],
    BUSINESS_READER: ['REVENUE_R', 'BUSINESS_R'],
    BLOG_ADMIN: ['BLOG_RW'],
    DEV_MANAGER_ADMIN: ['DEV_MANAGE_R', 'DEV_MANAGE_RW', 'DEV_BUSINESS_RW'],
    DP_ADMIN: ['NOTICE_RW'],
    GAME_ADMIN: [
        'GAME_UPLOAD_RW',
        'GAME_RW',
        'GAME_R',
        'GAME_MINIMAL_R',
        'TAG_RW',
        'TAG_R',
        'TAG_MINIMAL_R',
        'HOMEPAGE_TEXT_RW',
        'GAME_BUSINESS_REVIEW_RW',
        'GAME_BUSINESS_COMMON_RW',
        'GAME_XSOLLA_RW',
    ],
    GAME_READER: ['GAME_R', 'GAME_MINIMAL_R', 'TAG_R', 'TAG_MINIMAL_R', 'REVENUE_R'],
    GAME_BUSINESS_ADMIN: ['GAME_R', 'GAME_MINIMAL_R', 'REVENUE_R', 'GAME_BUSINESS_REVIEW_RW', 'TAG_R', 'TAG_MINIMAL_R'],
    GAME_SEO_ADMIN: [
        'GAME_RW',
        'GAME_R',
        'GAME_MINIMAL_R',
        'TAG_RW',
        'TAG_R',
        'TAG_MINIMAL_R',
        'HOMEPAGE_TEXT_RW',
        // game and submission pages are now one page on DP, which means we try to fetch submission for SEO admins also, which has some REVENUE_R fields
        // a more complex workaround is to query specific fields from submission type, but we decided to go with this simpler solution for now
        'REVENUE_R',
    ],
    PORTAL_COPYWRITER: ['HOMEPAGE_TEXT_RW'],
    ENGINEER: ['GAM_RW', 'GAME_RW', 'GAME_R', 'GAME_MINIMAL_R', 'TAG_RW', 'TAG_R', 'TAG_MINIMAL_R', 'DEV_MANAGE_R', 'REVENUE_R'],
};
exports.ADMIN_ROLES = [
    'ADS_ADMIN',
    'MAIN_APPADS_ADMIN',
    'PUBLISHING_APPADS_ADMIN',
    'FINANCE_ADMIN',
    'BUSINESS_ADMIN',
    'BUSINESS_READER',
    'BLOG_ADMIN',
    'DEV_MANAGER_ADMIN',
    'DP_ADMIN',
    'GAME_ADMIN',
    'GAME_READER',
    'GAME_SEO_ADMIN',
    'ADMIN',
    'SUPER_ADMIN',
    'ENGINEER',
];
exports.SUBMISSION_ROLES = ['GAME_BUSINESS_ADMIN'];
exports.COPYWRITER_ROLES = ['PORTAL_COPYWRITER', 'COPYWRITER', 'SUPER_ADMIN'];
